import { NavItem, Select } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useVatDeclarationPeriods } from '@features/vatDeclarations/hooks/useVatDeclarationPeriods'
import { getVatDeclarationPeriodItems } from '@features/vatDeclarations/utils/getVatDeclarationPeriodItems'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useFormContext } from '../../../../../../../../hooks'
import { OrganizationAccountingFormSchema } from '../../../../utils/organizationAccountingSettingsFormData'

export const SalesTaxPeriodFormItem = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { vatDeclarationPeriods, isLoading } = useVatDeclarationPeriods()
  const { FormItem } = useFormContext<OrganizationAccountingFormSchema>()
  const canUseVatReportSelect = !!organization?.isVatExempted

  const salesTaxPeriodItems: NavItem<string>[] = useMemo(
    () => getVatDeclarationPeriodItems(vatDeclarationPeriods),
    [vatDeclarationPeriods],
  )

  return (
    <FormItem
      name="salesTaxPeriod"
      label={t('settings.organization.accounting.vat_report')}
      render={({ field: { onChange, value, ...rest } }) => (
        <Select
          selectedId={value}
          items={salesTaxPeriodItems}
          onSelect={onChange}
          dropdownSize="fitTrigger"
          disabled={canUseVatReportSelect}
          dropdownFetching={isLoading}
          {...rest}
        />
      )}
    />
  )
}
